import { DefaultSecondaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import PlusMinusNumberInput from '../../../components/plus-minus-number-input/plus-minus-number-input.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import { useBasketOverview } from './basket-overview.controller';

const ID = 'basket-overview';

export const BasketOverview = () => {
    const viewProps = useBasketOverview();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.OBJECTS.BASKET.DEFAULT, onBack: viewProps.onBack }}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.continueToDeliveryLocation,
                submitDisabled: viewProps.basketItems.length === 0,
                submitLabel: CommonMessage.BUTTONS.CHOOSE_DELIVERY_LOCATION
            }}>
            {viewProps.basketItems.length === 0 ? (
                <p className='text-foreground-muted text-center'>
                    <FormattedMessage
                        id='kiosk.wizard.basket-overview.empty'
                        defaultMessage='Your basket is empty'
                        description='Empty-state message on the kiosk order basket screen'
                    />
                </p>
            ) : (
                <div className='flex flex-col gap-4'>
                    {viewProps.basketItems.map((item) => (
                        <div
                            key={item.product.id}
                            className='bg-background-surface border-border-default flex flex-col gap-3 rounded-xl border p-3'>
                            <ProductCard
                                product={item.product}
                                variant='attributes'
                            />
                            <div className='flex items-center justify-between'>
                                <DefaultSecondaryButton
                                    text={
                                        <FormattedMessage
                                            id='kiosk.wizard.basket-overview.remove-product'
                                            defaultMessage='Remove product'
                                            description='Button that removes a product from the kiosk order basket'
                                        />
                                    }
                                    onClick={() => viewProps.updateBasketItem(item.product.id, 0)}
                                />
                                <PlusMinusNumberInput
                                    min={1}
                                    max={99}
                                    value={item.quantity}
                                    onChange={(quantity) => viewProps.updateBasketItem(item.product.id, quantity)}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </WizardScreenContainer>
    );
};
